import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import Editor from '../../../../../components/editor/Editor';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditQuestion';

export const QuestionsForm = ({ touched, errors, values, setFieldValue, readOnly }: StepProps) => {
  return (
    <Row>
      <Col xs={12}>
        <FormStepHeader title="Question Details" showRequiredLegend={!readOnly} />
      </Col>
      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="name"
        >
          <FormLabel required>Name</FormLabel>
          <Field
            name="name"
            type="text"
            as={Form.Control}
            isInvalid={touched.name && !!errors.name}
            aria-required
          />
          <ErrorMessage name="name">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>

      <Col
        xs={12}
        lg={12}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-10"
          controlId="details"
        >
          <FormLabel required>Answer</FormLabel>
          <Field
            name="answer"
            component={Editor}
            className="form-control"
            isInvalid={touched.answer && !!errors.answer}
            aria-required
          />
          <ErrorMessage name="answer">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>

      <Col
        xs={12}
        lg={6}
        className="pe-1"
      >
        <Form.Group
          className="mb-lg-3 mb-1"
          controlId="is_public"
        >
          <FormLabel>Question Type</FormLabel>
          <Form.Control
            as="select"
            name="question_type"
            value={values?.question_type}
            onChange={(e) => setFieldValue!('question_type', e.target.value)}
            isInvalid={touched.question_type && !!errors.question_type}
          >
            <option>Select</option>
            <option value="online">Online</option>
            <option value="in_person">In person</option>
            <option value="private_event">Private event</option>
            <option value="class_theme_descriptions">Class theme descriptions</option>
          </Form.Control>
          <ErrorMessage name="is_public">
            {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
          </ErrorMessage>
        </Form.Group>
      </Col>
    </Row>
  );
};
